import api from "./api";
import { uploadToPresignedPost } from "./uploadService";
// @ts-expect-error - api is not typed
const { get, post } = api.getPrefixedMethods("historical-analysis");
export const historicalAnalysisService = {
    getCompanies: () => get("companies"),
    listRuns: (params = {}) => get("runs", { params }),
    getRun: (id) => get(`runs/${id}`),
    createRun: (data) => post("runs", data),
    startRun: (id, data) => post(`runs/${id}/start`, data),
    startCapture: (id, data) => post(`runs/${id}/start-capture`, data),
    cancelRun: (id) => post(`runs/${id}/cancel`, {}),
    retryFailed: (id) => post(`runs/${id}/retry-failed`, {}),
    downloadReport: (id) => get(`runs/${id}/download`),
    /** Get a run-scoped presigned URL, upload the file to S3, and return its S3 key. */
    async uploadBundle(runId, file) {
        const { key, upload } = await post(`runs/${runId}/upload-url`, { fileName: file.name });
        await uploadToPresignedPost(upload, file, file.name);
        return key;
    },
};
